module.exports = __webpack_public_path__ + "img/logocharged.6ba67f40.png";